module.exports = __webpack_public_path__ + "static/media/7774.3f03e027.jpg";